import React, { Fragment, Component } from 'react';
import './TabContainer.css';
import Slider from '../../Slider/index';
class TabContainer extends Component {  

  render() {
    return (
      <Fragment>
        {/* <div className="sticky"> */}
          <table className="metrictable">
            <thead>
              <tr>
                <th className="column_slider">Scored Range and Metric Score</th>
                <th className="column_points">
                  <div className="bubble">Current Points</div>
                </th>
                <th className="column_points projected">
                  <div className="bubble">Projected Points</div>
                </th>
                <th className="column_change">
                  <div className="bubble">Projected Change</div>
                </th>
                <th className="column_reset" ></th>
              </tr>
            </thead>

          <tbody>
            {this.props.metrics.data
              .filter(item => {
                return (
                  item[0] === this.props.label.toUpperCase() &&
                  Number(item[3]) !== 999 &&
                  !item[1].includes('*')
                );
              })
              .sort((a ,b) => a[13] - b[13])
              .map(infoData => {
                  return (
                    <tr key={Math.random()}>
                      <Slider
                        key={infoData[0] + '|' + infoData[1]}
                        domain={infoData[0]}
                        metric={infoData[1]}
                        value={infoData[2]?0:(infoData[10])}
                        originalValue={(infoData[11])}
                        inRangeMax={infoData[4]}
                        inRangeMin={infoData[5]}
                        ptsPossible={infoData[8]}
                        hardPtsPossible={infoData[14]}
                        disableFlag={infoData[2]}
                        hardDisableFlag={Number(infoData[3])>=992 && Number(infoData[3])<999 
                          ?
                          1
                          : 0}
                        exceptionNumber={Number(infoData[3])}
                        ptsEarned={
                          Number(infoData[3])>=992 && Number(infoData[3])<999 
                          ?
                          0
                          :        
                          infoData[9]}
                        handler={this.props.sliderHandle}
                        handlerDisable={this.props.handlerDisable}
                        sortOrder={infoData[13]}
                        pctEarned={(infoData[16])}
                      />
                    </tr>
                  );
                }
              )}
          </tbody>
        </table>
      </Fragment>
    );
  }
}

export default TabContainer;
